module.exports = __webpack_public_path__ + "img/recycle.90591f8b.svg";